import React, { useContext, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaChartPie, FaClock, FaPlusCircle, FaMoneyBill, FaTasks, FaRegFilePdf, FaUserSlash, FaClipboardList, FaMoneyBillWave, FaReceipt } from "react-icons/fa";
import { MdPeople, MdLockOpen, MdCheckCircle, MdInventory, MdAttachMoney } from "react-icons/md";
import { IoMdSettings } from "react-icons/io";
import { FcSalesPerformance } from "react-icons/fc";
import { GiMoneyStack } from "react-icons/gi";

import { GlobalContext } from "../Context/GlobalState";
import { BASE_URL_API_TRANXT_UAT_API } from "../utils/Constant";
const iconMap = {
  "Admin Dashboard": <FaChartPie style={{ color: "Plum" }} />,
  "Employee Management": <MdPeople style={{ color: "#FFC300" }} />,
  "Salary Management": <FaChartPie style={{ color: "Plum" }} />,
  "Loan Management": <FaMoneyBillWave style={{ color: "#A8DF8E" }} />,
  "Perfomance": <FcSalesPerformance style={{ color: "#FEB941" }} />,
  "Attendance Management": <FaClock style={{ color: "Turquoise" }} />,
  "Projects": <FaPlusCircle style={{ color: "yellow" }} />,
  "Expense Management": <FaMoneyBill style={{ color: "Plum" }} />,
  "Payroll Management": <MdAttachMoney style={{ color: "yellow" }} />,
  "Expense Payroll": <FaPlusCircle style={{ color: "orange" }} />,
  "Arrear": <GiMoneyStack style={{ color: "green" }} />,
  "Contract": <MdAttachMoney style={{ color: "green" }} />,
  "Account Ledger": <MdAttachMoney style={{ color: "yellow" }} />,
  "Office Inventory": <MdInventory style={{ color: "#41B06E" }} />,
  "Leave Approval": <MdCheckCircle style={{ color: "pink" }} />,
  "Balance Leave": <FaClipboardList style={{ color: "#41B06E" }} />,
  "Add Leave/WFH": <MdCheckCircle style={{ color: "#DAF7A6" }} />,
  "Access": <MdLockOpen style={{ color: "yellow" }} />,
  "Create Workspace": <FaPlusCircle style={{ color: "green" }} />,
  "File": <FaReceipt style={{ color: "#FEB941" }} />,
  "Task Overview": <FaTasks style={{ color: "pink" }} />,
  "Policy": <FaRegFilePdf style={{ color: "red" }} />,
  "Inactive Employee": <FaUserSlash style={{ color: "#96C9F4" }} />,
  "Settings": <IoMdSettings style={{ color: "yellow" }} />,
};

const adminLinks = [
  { to: "/admin/AdminDashboard", name: "Admin Dashboard" },
  {
    to: "/admin/employee-management",
    name: "Employee Management",
    moduleName: "Employee Management",
    roleName: "Employee Management",
  },
  { to: "/admin/salary-management", name: "Salary Management" },
  { to: "/admin/loan-management", name: "Loan Management" },
  { to: "/admin/performance", name: "Perfomance" },
  {
    to: "/admin/attendance-management",
    name: "Attendance Management",
    moduleName: "Attendance Management",
    roleName: "Attendance Management",
  },
  { to: "/admin/Createproject", name: "Projects" },
  {
    to: "/admin/expense-management",
    name: "Expense Management",
    moduleName: "Expense Management",
    roleName: "View Expense",
  },
  {
    to: "/admin/payroll-management",
    name: "Payroll Management",
    moduleName: "Payroll Management",
    roleName: "View Payroll",
  },
  {
    to: "/admin/expense-payroll",
    name: "Expense Payroll",
    moduleName: "Expense Payroll Management",
    roleName: "View Expense Payroll",
  },
  { to: "/admin/arrear", name: "Arrear" },
  { to: "/admin/Contract", name: "Contract" },
  {
    to: "/admin/account-ledger",
    name: "Account Ledger",
    moduleName: "Ledger Management",
    roleName: "View Ledger",
  },
  { to: "/admin/office-inventory", name: "Office Inventory" },
  {
    to: "/admin/LeaveApprovalAdmin",
    name: "Leave Approval",
    moduleName: "Leave Management",
    roleName: "Approve/Reject Leave",
  },
  { to: "/admin/Balance-leave", name: "Balance Leave" },
  { to: "/admin/add-leave-wfh", name: "Add Leave/WFH" },
  { to: "/admin/access", name: "Access" },
  {
    to: "/admin/create-workspace",
    name: "Create Workspace",
    moduleName: "Project Management",
    roleName: "View Projects",
  },
   { to: "/admin/file", name: "File" },
  { to: "/admin/task-overview", name: "Task Overview" },
  {
    to: "/admin/policy",
    name: "Policy",
    moduleName: "Policy Management",
    roleName: "View Policy",
  },
  { to: "/admin/inactive-employee", name: "Inactive Employee" },
  { to: "/admin/admin-settings", name: "Settings" },
];

const AdminSidebar = () => {
  const { pathname } = useLocation();
  const { user, accessData, setAccessData } = useContext(GlobalContext);

  const fetchAccessData = async () => {
    try {
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/GetAccessManagementSuperAdmin`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ firmid: user.firm_id, empid: user.userid }),
        }
      );
      const data = await res.json();
      if (data.status === "0") setAccessData(data.data);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (user?.firm_id && user?.userid) fetchAccessData();
  }, [user]);


  const navigationLinks = adminLinks.map((link) => {
    let access = true;
    if (link.moduleName && link.roleName) {
      const moduleData = accessData?.find((m) => m.module_name === link.moduleName);
      const dataArray = Array.isArray(moduleData?.data) ? moduleData.data : [];
      access = !!dataArray.find((r) => r.role_name?.trim() === link.roleName?.trim() && r.access === "Y");
    }
    return { ...link, access };
  });
  return (
    <div style={{ width: "220px", minHeight: "100vh", backgroundColor: "#212529", color: "white" }}>
      <ul className="list-unstyled p-3 mt-3 mb-0">
        <h5 className="mx-2">Admin System</h5>
        <hr className="m-1" />
        {navigationLinks.map((link) => {
          const access = link.access !== false;
          return (
            <li
              key={link.to}
              className={`p-2 d-flex align-items-center ${pathname === link.to ? "bg-light text-dark" : ""}`}
              style={{ opacity: access ? 1 : 0.5, pointerEvents: access ? "auto" : "none" }}
              title={access ? "" : "Access Denied"}
            >
              <Link
                to={access ? link.to : "#"}
                className="text-decoration-none d-flex align-items-center w-100"
                style={{ color: pathname === link.to ? "#000" : "#fff", fontSize: ".8rem", fontWeight: "200" }}
              >
                <span className="me-2" style={{ fontSize: ".9rem" }}>
                  {iconMap[link.name] || null}
                </span>
                {link.name}
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default AdminSidebar;
